module.exports = __webpack_public_path__ + "components/home-header/static/header-4--large@2x-0115c44e2dec12e05bd5e10d98b69ddd.jpg";